/* ***************************************************
 アコーディオン
*************************************************** */
$('.accordion-header').click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass('active');
});

/* ***************************************************
 splide
*************************************************** */
document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.splide', {
    // autoplay: true, 
    type: "loop", // ループ
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    // perPage: 1,
    // perMove: 1,
    focus: 0,
    interval: 2000, // 自動再生の間隔
    speed: 1500, // スライダーの移動時間
    slideFocus: true,
    padding: "8px", // スライダーの左右の余白
    gap: 8, // スライド間の余白
    arrows: false, // 矢印ボタンを非表示
    autoScroll: {
      speed: 0.8,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  }).mount(window.splide.Extensions);
});


/* ***************************************************
 クーポンコードコピー
*************************************************** */
document.querySelectorAll('.coupon-wrap').forEach(function (wrap) {
  var tooltip = wrap.querySelector('.coupon-tooltip');
  var hideTimer;

  wrap.addEventListener('click', function () {
    var code = wrap.getAttribute('data-code');
    copyToClipboard(code);

    clearTimeout(hideTimer);
    tooltip.classList.add('show');
    hideTimer = setTimeout(function () {
      tooltip.classList.remove('show');
    }, 1200);
  });
});

function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(function () {
      fallbackCopy(text);
    });
  } else {
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  var ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
}